// @ts-strict

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { BaseApiResponse, IUserBasicInfo } from '../../models/core-models';
import { share, shareReplay, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class GetUserBasicDataService {
  public shareUserDataSubject = new BehaviorSubject<IUserBasicInfo | null>(null);
  public shareUserData$: Observable<IUserBasicInfo | null> = this.shareUserDataSubject.asObservable();

  constructor(private http: HttpClient) {}

  public checkUserInfo(): void {
    const storedUserData = localStorage.getItem('basic_user_data');
    if (!storedUserData) {
      this.getBasicUserInfo()
        .pipe(shareReplay(1))
        .subscribe(res => {
          if (res.data) {
            this.shareUserDataSubject.next(res.data);
            localStorage.setItem('basic_user_data', JSON.stringify(res.data));
          }
        });
    } else {
      this.shareUserDataSubject.next(JSON.parse(storedUserData) as IUserBasicInfo);
    }
  }

  public getBasicUserInfo(): Observable<BaseApiResponse<IUserBasicInfo>> {
    return this.http.get<BaseApiResponse<IUserBasicInfo>>(environment.apiUrl + `/user/me`).pipe(
      shareReplay(1),
      tap(user => {
        if (user.data) {
          // console.log(user?.data?.user?.user_id);
          this.shareUserDataSubject.next(user.data);
          localStorage.setItem('basic_user_data', JSON.stringify(user?.data));
        }

        // Assuming userId and username are already in the dataLayer
        const userId = user?.data?.user?.user_id;
        const username = user?.data?.user?.username;
        // Find the index of the element you want to update
        const indexToUpdate = window.dataLayer.findIndex(item => item.userId === userId);

        // If the element exists, update it; otherwise, push a new one
        if (indexToUpdate !== -1) {
          window.dataLayer[indexToUpdate].userId = userId;
          window.dataLayer[indexToUpdate].username = username;
        } else {
          window.dataLayer.push({
            userId: userId,
            username: username
          });
        }
      })
    );
  }
}
